import router from './router'
import store from './store'
import { Notify } from 'vant'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 配置无需权限可访问的路由，官网页面的名单
const whiteList = ['/login', '/', '/sign', '/retrieve', '/register', '/defLogin', '/Bcaseinformation', '/mediatelistSee', '/rulessee', '/mediatelist', '/mediate', '/successnew', '/failed', '/success', '/zj', '/execute', '/signanew', '/signan', '/nsign', '/info', '/signature', '/downloadapp', '/video', '/repay', '/im', '/convey', '/up', '/visualization', '/auth-redirect', '/404', '/home', '/contact', '/about', '/join', '/business', '/holdcourt', '/notice', '/news', '/newsbody', '/rules', '/courtnotice', '/noticebody', '/litigationPDF'] // no redirect whitelist

import common from '@/utils/common'

router.beforeEach(async(to, from, next) => {
  const GET_WEB_MEANS = JSON.parse(sessionStorage.getItem('GET_WEB_MEANS'))

  if (common.isEmpty(GET_WEB_MEANS)) {
    await store.dispatch('user/GetWebMeansNew')
  }

  document.title = to.path === '/info' || to.path === '/signanew' || to.path === '/signan' || to.path === '/nsign' ? '' : ''

  let in_path = false
  for (const v of whiteList) {
    if (v == to.path) {
      in_path = true
    }
  }
  if (in_path) {
    next()
  } else {
    NProgress.start()
    // set page title
    // determine whether the user has logged in
    const hasToken = getToken()
    if (hasToken) {
      if (to.path === '/login') {
        // if is logged in, redirect to the home page
        next({ path: '/' })
        NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
      } else {
        // determine whether the user has obtained his permission roles through getInfo
        const hasRoles = store.getters.roles && store.getters.roles.length > 0
        if (hasRoles) {
          next()
        } else {
          try {
            // get user info
            // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
            const { roles } = await store.dispatch('user/getInfo')

            // generate accessible routes map based on roles
            // const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

            // dynamically add accessible routes
            // router.addRoutes(accessRoutes)

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({ ...to, replace: true })
          } catch (error) {
            // remove token and go to login page to re-login
            await store.dispatch('user/resetToken')
            Notify.error(error || '请求错误')
            next(`/login?redirect=${to.path}`)
            NProgress.done()
          }
        }
      }
    } else {
      /* has no token*/

      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly
        next()
      } else {
        // other pages that do not have permission to access are redirected to the login page.
        next(`/defLogin`)
        NProgress.done()
      }
    }
  }
  // start progress bar
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
